/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
document.addEventListener("DOMContentLoaded", function() {
    console.log(1111);
    const productImages = document.querySelector('.product__images');
    const productSlides = productImages.querySelector('.product__slides');
    productImages.insertAdjacentHTML('beforeend','<div class="indicator-wrap"><div id="scrollIndicator"><div class="visual"></div></div></div>');
    const scrollIndicator = document.getElementById('scrollIndicator');
    const indicatorWrap = document.querySelector('.indicator-wrap');

    let isDragging = false;
    let startX, startScrollLeft, timeout;
    function updateScrollIndicatorWidth() {

        let scrollIndicatorWidth = productSlides.clientWidth * productSlides.clientWidth / productSlides.scrollWidth;
        scrollIndicator.style.width = scrollIndicatorWidth + 'px';
    }

    function updateScrollIndicatorPosition() {

        let scrollPercentage = productSlides.scrollLeft / (productSlides.scrollWidth - productSlides.clientWidth);
        scrollIndicator.style.left = (scrollPercentage * (indicatorWrap.clientWidth - scrollIndicator.offsetWidth)) + 'px';
    }

    updateScrollIndicatorWidth();
    updateScrollIndicatorPosition();

    productSlides.addEventListener('scroll', function (){
        if(!isDragging)
        updateScrollIndicatorPosition();

    });
    window.addEventListener('resize', updateScrollIndicatorWidth);

    indicatorWrap.addEventListener('click', function(e) {
        const rect = indicatorWrap.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const scrollWidth = productSlides.scrollWidth - productSlides.clientWidth;
        const newScrollLeft = (clickX / indicatorWrap.clientWidth) * scrollWidth;
        productSlides.scrollLeft = newScrollLeft;
    });



    function startDrag(e) {
        isDragging = true;
        startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        startScrollLeft = productSlides.scrollLeft;
        e.preventDefault();
    }

    function doDrag(e) {
        if (!isDragging) return;
        e.preventDefault();
        const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
        const deltaX = clientX - startX;
        const maxScrollLeft = productSlides.scrollWidth - productSlides.clientWidth;
        productSlides.scrollLeft = startScrollLeft + (deltaX * (maxScrollLeft / (indicatorWrap.clientWidth - scrollIndicator.offsetWidth)));

        let scrollPercentage = (deltaX / (indicatorWrap.clientWidth - scrollIndicator.offsetWidth));
        var left = clientX - scrollIndicator.offsetWidth;

        if(left > 0)
            left = Math.min(left,(indicatorWrap.clientWidth - scrollIndicator.offsetWidth));
        else
            left = 0;
        scrollIndicator.style.left =  left + 'px';
        //scrollIndicator.style.left = (scrollPercentage * (indicatorWrap.clientWidth - scrollIndicator.offsetWidth)) + 'px';
    }

    function stopDrag() {

            if(isDragging) {
                clearTimeout(timeout);
                setTimeout(function (){
                    isDragging = false;
                    updateScrollIndicatorPosition();
                },350);
            }

    }

    scrollIndicator.addEventListener('mousedown', startDrag);
    document.addEventListener('mousemove', doDrag);
    document.addEventListener('mouseup', stopDrag);

    scrollIndicator.addEventListener('touchstart', startDrag, { passive: false });
    document.addEventListener('touchmove', doDrag, { passive: false });
    document.addEventListener('touchend', stopDrag);

    scrollIndicator.ondragstart = function() {
        return false;
    };


});
function updateDiscountProgress(){
    let count;
    if('cart' in window)
        count = window.cart.getCartItemCount();
    else
        count = window.cartCount;

    let width = 0;
    let active = null;
    if(count == 0){
        width = 0;
    }
    else if(count == 1) {
        width = '33.333333';
    }
    else if (count == 2) {
        width = '66.666';
        active = document.querySelector('.cart-progress .p50');
    }
    else if (count >= 3) {
        width = '100';
        active = document.querySelector('.cart-progress .p100');
    }
    /*else {
        width = 100;
        active = document.querySelector('.cart-progress .p100');
    }*/

    document.querySelectorAll('.cart-progress .item').forEach((e)=>e.classList.remove('active'))
    document.querySelector('.cart-progress .tiers-progress-bar-fill').style.width=width+'%';
    if(active)
        active.classList.add('active');

}
function checkProgressCart(){
    if(document.querySelector('.cart-progress')){
        updateDiscountProgress()
    } else setTimeout(checkProgressCart,100);
}
checkProgressCart();
document.addEventListener('theme:cart:update',updateDiscountProgress);
document.addEventListener('theme:product:added',updateDiscountProgress);

